import { gql } from '__generated__';

export const MessageAttributesFragment = gql(`
  fragment MessageAttributes on Message {
    id
    title
    subject
    content
    allowed_placeholders
    deletable
    draft
    sendable
    remaining_count
    last_sent_at
    scheduled_at
    event {
      id
      title
      locale
      brand_color
      logo {
        id
        url
      }
      mail_permissions {
        id
        title
      }
    }
    filters {
      ...ParticipantFilters
      registration_filters {
        ...RegistrationFilters
      }
      order_filters {
        ...OrderFilters
        purchase_filters {
          ...PurchaseFilters
        }
      }
    }
  }
`);

export default gql(`
  query GetMessage($project_id: ID!, $message_id: ID!) {
    project(id: $project_id) {
      id
      message(id: $message_id) {
        ...MessageAttributes
      }
    }
  }
`);
